import { animate, group, query, state, style, transition, trigger } from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
    transition('* => CurrentInformationComponent', [
        query(
            ':enter',
            [
                style({
                    transform: 'translateY(100%)',
                    top: 0,
                    position: 'absolute',
                }),
                animate('0.3s ease-in')
            ],
            {optional: true}
        ),
    ]),
    transition('CurrentInformationComponent => *', [
        query(
            ':leave',
            [
                style({
                    position: 'absolute',
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 5000,
                    transform: 'translateY(0)',
                }),
                animate('0.3s ease-in', style({
                    position: 'absolute',
                    top: 0,
                    height: '100%',
                    width: '100%',
                    transform: 'translateY(100vh)',
                    'z-index': 5000,
                }))
            ],
            {optional: true}
        ),
    ]),
    transition('* => *', [
        query(
            ':enter',
            [style({opacity: 0}), animate('0.6s linear', style({opacity: 1}))],
            {optional: true}
        )
    ])
]);

export const fillScreenAnimation = trigger('fillScreenAnimation', [
    transition('void => *', [
        animate(150, style({
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
        }))
    ])
]);

export const fadeAnimationQuick = trigger('fadeAnimationQuick', [
    // The '* => *' will trigger the animation to change between any two states
    transition('* => *', [
        query(
            ':enter',
            [style({opacity: 0}), animate('0.3s linear', style({opacity: 1}))],
            {optional: true}
        )
    ])
]);

export const fadeIn = trigger('fadeIn', [
    transition(':enter', [   // :enter is alias to 'void => *'
        style({opacity: 0}),
        animate(300, style({opacity: 1}))
    ]),
    transition(':leave', [   // :leave is alias to '* => void'
        animate(0, style({opacity: 0}))
    ])
]);

export const chartSlideInOut = trigger('chartSlideInOut', [
    state('in', style({
        'max-height': '400px', opacity: '1', visibility: 'visible'
    })),
    state('out', style({
        'max-height': '0px', opacity: '0', visibility: 'hidden'
    })),
    transition('in => out', [group([
            animate('200ms ease-in-out', style({
                opacity: '0'
            })),
            animate('300ms ease-in-out', style({
                'max-height': '0px'
            })),
            animate('350ms ease-in-out', style({
                visibility: 'hidden'
            }))
        ]
    )]),
    transition('out => in', [group([
            animate('1ms ease-in-out', style({
                visibility: 'visible'
            })),
            animate('300ms ease-in-out', style({
                'max-height': '400px'
            })),
            animate('400ms ease-in-out', style({
                opacity: '1'
            }))
        ]
    )])
]);

const generateSwipeEnterTransition = (isRight: boolean) => {
    const targetState = isRight ? 'right' : 'left';
    const translateXAmount = isRight ? 500 : -500;
    return transition(`void => ${targetState}`, query(
        ':enter',
        [
            style({transform: `translateX(${translateXAmount}%)`}),
            animate('0.2s linear')
        ],
        {optional: true}
    ));
};

const generateSwipeLeaveTransition = (isRight: boolean) => {
    const sourceState = isRight ? 'right' : 'left';
    const translateXAmount = isRight ? -500 : 500;
    return transition(`${sourceState} => void`, query(
        ':leave',
        [
            animate(
                '0s linear',
                style({transform: `translateX(${translateXAmount}%)`})
            )
        ],
        {optional: true}
    ));
};

export const graphicBehaviorSwipe = trigger('graphicBehaviorSwipe', [
    generateSwipeEnterTransition(true),
    generateSwipeEnterTransition(false),
    generateSwipeLeaveTransition(true),
    generateSwipeLeaveTransition(false),
]);

